import {BaseViewModel} from "../../../infrastructure/models/base-view-model";

export class RadioButtonViewModel extends BaseViewModel {
  type: String;
  _id: String;
  _name: String;
  checked: Boolean;

  constructor(type: String, text: String, checked: Boolean) {
    super();

    this._id = text;
    this.type = type;
    this._name = text;
    this.checked = checked;
  }

  get id(): Number {
    return this._id;
  }

  get name(): String {
    return this._name;
  }
}

